import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiChevronLeft, FiChevronRight } = FiIcons;

function Pagination({ currentPage, totalItems, pageSize, onPageChange, onPageSizeChange, className = "" }) {
  const totalPages = Math.ceil(totalItems / pageSize);
  const startItem = totalItems === 0 ? 0 : (currentPage - 1) * pageSize + 1;
  const endItem = Math.min(currentPage * pageSize, totalItems);

  if (totalItems === 0) return null;

  return (
    <div className={`flex flex-col sm:flex-row items-center justify-between px-6 py-4 border-t border-gray-100 bg-gray-50 rounded-b-xl gap-4 ${className}`}>
      <div className="flex items-center gap-2 text-xs text-gray-500 font-medium whitespace-nowrap">
        <span>Zeige</span>
        <span className="font-bold text-gray-900">{startItem}-{endItem}</span>
        <span>von</span>
        <span className="font-bold text-gray-900">{totalItems}</span>
      </div>
      
      <div className="flex items-center gap-2">
        {onPageSizeChange && (
          <select 
            value={pageSize} 
            onChange={(e) => {
              onPageSizeChange(Number(e.target.value));
              onPageChange(1); // Reset to page 1 on size change
            }}
            className="bg-white border border-gray-200 text-xs font-bold text-gray-700 rounded-lg px-2 py-1.5 outline-none focus:border-blue-500 mr-2 cursor-pointer shadow-sm"
          >
            <option value={15}>15 pro Seite</option>
            <option value={30}>30 pro Seite</option>
            <option value={50}>50 pro Seite</option>
            <option value={100}>100 pro Seite</option>
          </select>
        )}

        <button
          onClick={() => onPageChange(Math.max(1, currentPage - 1))}
          disabled={currentPage === 1}
          className="p-2 rounded-lg border border-gray-200 bg-white text-gray-600 disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-100 transition-colors shadow-sm"
        >
          <SafeIcon icon={FiChevronLeft} />
        </button>
        
        <span className="text-xs font-bold text-gray-700 min-w-[4rem] text-center">
          Seite {currentPage} / {totalPages}
        </span>

        <button
          onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))}
          disabled={currentPage === totalPages}
          className="p-2 rounded-lg border border-gray-200 bg-white text-gray-600 disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-100 transition-colors shadow-sm"
        >
          <SafeIcon icon={FiChevronRight} />
        </button>
      </div>
    </div>
  );
}

export default Pagination;